export enum Sides {
  LEFT = 0,
  RIGHT = 1,
  BACK = 2,
  FRONT = 3,
  BOTTOM = 4,
  TOP = 5,
}
